import React from 'react';
import ChartComponent from './ChartComponent';

const FulfillmentTimeChart = ({ data }) => {
  // Utility function to calculate difference in minutes
  const calculateDifferenceInMinutes = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate - startDate; // Difference in milliseconds
    const diffMinutes = diffMs / (1000 * 60); // Convert to minutes
    return diffMinutes;
  };

  // Prepare data for Chart.js
  const chartData = {
    labels: data.map((item) => `Order ${item.id}`),
    datasets: [
      {
        label: 'Time to Fulfillment (Minutes)',
        data: data.map((item) =>
          calculateDifferenceInMinutes(item.created_at, item.updated_at).toFixed(2)
        ),
        backgroundColor: 'rgba(75, 192, 192, 0.6)', // Teal color for bars
        borderColor: 'rgba(75, 192, 192, 1)', // Border color for bars
        borderWidth: 1,
        borderRadius: 8, // Rounded corners for the bars
      },
    ],
  };

  // Define chart options
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend for a cleaner look
      },
      title: {
        display: true,
        text: 'Time to Fulfillment', // Chart title
        font: {
          size: 18,
          weight: 'bold',
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Y-axis starts at zero
        title: {
          display: true,
          text: 'Time (Minutes)', // Y-axis title
          font: {
            size: 14,
          },
        },
        grid: {
          display: false, // Remove grid lines for a cleaner look
        },
      },
      x: {
        title: {
          display: true,
          text: 'Order', // X-axis title
          font: {
            size: 14,
          },
        },
        ticks: {
          autoSkip: false, // Prevent skipping order labels
        },
        grid: {
          display: false, // Remove grid lines for a cleaner look
        },
      },
    },
  };

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ChartComponent type="bar" data={chartData} options={chartOptions} />
    </div>
  );
};

export default FulfillmentTimeChart;
